import { render, staticRenderFns } from "./online-gaming.vue?vue&type=template&id=4865441e&scoped=true&"
import script from "./online-gaming.vue?vue&type=script&lang=js&"
export * from "./online-gaming.vue?vue&type=script&lang=js&"
import style0 from "./online-gaming.vue?vue&type=style&index=0&id=4865441e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4865441e",
  null
  
)

export default component.exports